import { CircularProgress, LinearProgress } from "@mui/material";
import { CMCircularProgress, CMLinearProgress } from "./progress.styles";
import iconUrl from '../../Assets/increase.png'; 

export const PROGRESS_TYPE = {
    circular: 'circular-progress',
    linear: 'linear-progress',
}

const getProgress = (progressType = PROGRESS_TYPE.circular) => (
    {   [PROGRESS_TYPE.circular]: CustomCircularProgress,
        [PROGRESS_TYPE.linear]: CustomLinearProgress,
    }[progressType]
)

const Progress = ({ value, progressType, className, conditionIcon }) => {
    const CMProgress = getProgress(progressType);

    return (
        <>
            <CMProgress 
                value={value} 
                className={className} 
                conditionIcon={conditionIcon} 
            />
        </>
    );
};

const CustomCircularProgress = ({ value, conditionIcon, ...props }) => {
    
    return (
        <CMCircularProgress value={value} {...props}>
            {value && value > 0 ? (
                <div>
                    <svg viewBox="0 0 56 18">
                        <text x="50%" y="50%">{`${value}%`}</text>
                    </svg>
                </div>
            ) : (
                ''
            )}
            <CircularProgress thickness={4} size={'100%'} value={100} variant='determinate' className="placeholder-progress" />
            <CircularProgress thickness={4} size={'100%'} value={value} variant='determinate' className="current-progress" />
            {conditionIcon && (
                <img src={iconUrl} alt="Icon" style={{ width: '15px', height: '15px', marginTop: '10px' }} />
            )}
        </CMCircularProgress>
    );
}


const CustomLinearProgress = ({ value, conditionIcon, ...props }) => {
    const progressValue = Math.min(value, 100); 
    return (
        <CMLinearProgress value={progressValue} {...props}>
            {value !== undefined && value > 0 && value < 10 ? (
                <div className="progressLabel" style={{ marginLeft: '5px' }}>
                    <p>{`${value}%`}</p>
                    {conditionIcon && <img src={iconUrl} alt="Icon" style={{ width: '15px', height: '15px', marginRight: '5px' }} />}
                </div>
            ) : (
                value !== undefined && value >= 10 ? (
                    <div className="progressLabel">
                        <p>{`${value}%`}</p>
                        {conditionIcon && <img src={iconUrl} alt="Icon" style={{ width: '15px', height: '15px', marginRight: '5px' }} />}
                    </div>
                ) : (
                    <div className="progressLabel" style={{ marginLeft: '5px' }}>
                        <p>0%</p>
                        {conditionIcon && <img src={iconUrl} alt="Icon" style={{ width: '15px', height: '15px', marginRight: '5px' }} />}
                    </div>
                )
            )}
            <LinearProgress variant="determinate" value={progressValue} className="linear-progress" />
        </CMLinearProgress>
    );
}

export default Progress;